import React from 'react';
import { Button } from '@fiverr-private/fit';
import { func, string } from 'prop-types';
import { Base } from '@fiverr-private/modal/src';
import ModalBody from '../ModalBody';
import { GENERAL_VIDEO_MODAL_NAME, VIDEO_PROP_TYPES } from '../constants';
import '../index.scss';

const BannerVideo = ({
    text,
    video,
    onOpen,
    sourceInfo
}) => (
    <Base name={GENERAL_VIDEO_MODAL_NAME}
        trigger={({ open }) => (
            <Button onClick={open} className="btn-play" size={Button.SIZES.LARGE}>
                { text }
            </Button>
        )}
        onOpen={onOpen}>
        {() => <ModalBody video={video} sourceInfo={sourceInfo}/>}
    </Base>
);

BannerVideo.propTypes = {
    ...VIDEO_PROP_TYPES,
    text: string,
    onOpen: func
};

export default BannerVideo;
